// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"278":"b7402983","622":"768a1c70","628":"95a2191f"}[chunkId] + ".chunk.css";
};